import React from "react";
import Button from "Components/button/Button";
import Input from "Components/input/Input";
import WarningBanner from "Components/warningBanner/WarningBanner";
import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";
import TranslatedString from "Components/TranslatedString";
import Select from "Components/select/Select";
import t from "Utils/translation";
import cx from "classnames";
import { allCountries } from "@/config";
import s from "./details.scss";
import { tzs, getPanelLangs } from "@/config.js";
import { Icon, infoFill } from "Icons/index";
import AvailabilityBox from "Components/availabilityBox/AvailabilityBox";

export default class DetailsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewFields: [
        "firstname",
        "lastname",
        "language",
        "timezone",
        "secondary_email",
        "country",
        "state",
        "zip",
        "address",
        "company",
        "role",
        "organizational_unit",
        "telephone",
        "mobilephone",
        "fax",
        "city",
      ],
    };
  }

  componentWillUnmount() {
    this.props.resetFields(...this.state.viewFields);
  }

  render() {
    const {
      emailAccount,
      isFormLoading,
      setFormFieldValue,
      submitForm,
      formData,
      formErrors,
      loggedUserType,
      domain: {
        plan: { features },
      },
    } = this.props;

    return (
      <form className={s.registry} method="post" onSubmit={(e) => submitForm(e, this.state.viewFields)}>
        <div className={s.wrapInfoBtn}>
          <div className={s.warnignMsg}>
            {!formErrors.onForm && !this.props.areFieldsPristine(...this.state.viewFields) && (
              <WarningBanner color="yellow-text" msg={<TranslatedString>infoMsg.unsaveChanged</TranslatedString>} />
            )}

            {formErrors.onForm && <WarningBanner msg={formErrors.onForm} color="red" />}
          </div>

          <div className={s.infoBtnGroup}>
            <Button className={s.docsBtn} docsKey="emailAccount_settings" color="docs" type="button">
              button.docs
            </Button>
            <Button className={s.saveBtn} type="submit" loading={isFormLoading} disabled={!this.props.canEdit}>
              button.save
            </Button>
          </div>
        </div>
        <div className={s.settings}>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.emailAccout.title")}</div>
              <div className="sectionDesc">{t("settings.sections.emailAccout.desc")}</div>
            </div>
            <div className="formsSectionSP">
              <Input
                className="inputFull2"
                name="firstname"
                label={t("input.label.firstName")}
                placeholder={t("input.placeholder.firstName")}
                type="text"
                onChange={setFormFieldValue}
                value={formData.firstname}
                errors={formErrors.firstname}
                required
                disabled={!this.props.canEdit}
              />

              <Input
                className="inputFull2"
                name="lastname"
                label={t("input.label.lastName")}
                placeholder={t("input.placeholder.lastName")}
                type="text"
                onChange={setFormFieldValue}
                value={formData.lastname}
                errors={formErrors.lastname}
                disabled={!this.props.canEdit}
              />

              <Select
                className="inputFull2"
                label={t("input.label.select.countryEmail")}
                components={{ DropdownIndicator }}
                name="country"
                options={allCountries}
                onChange={setFormFieldValue}
                clearable={false}
                value={formData.country}
              />

              <Input
                className="inputFull2 inputAddMargin"
                name="company"
                label={t("input.label.domain.company")}
                placeholder={t("input.placeholder.company")}
                type="text"
                onChange={setFormFieldValue}
                value={formData.company}
                errors={formErrors.company}
                disabled={true}
              />

              <AvailabilityBox
                forcedNotAvailable={!features.addressbook_data_complete}
                forcedMsg="infoMsg.advancedContactInfo"
              >
                <Input
                  className="inputFull2"
                  name="secondary_email"
                  label={t("input.label.email.secondaryEmail")}
                  placeholder={t("input.placeholder.email")}
                  type="email"
                  onChange={setFormFieldValue}
                  value={formData.secondary_email}
                  errors={formErrors.secondary_email}
                  disabled={!features.addressbook_data_complete || !this.props.canEdit}
                />

                <Input
                  name="role"
                  label={t("input.label.email.role")}
                  placeholder={t("input.placeholder.role")}
                  type="text"
                  onChange={setFormFieldValue}
                  value={formData.role}
                  errors={formErrors.role}
                  disabled={!features.addressbook_data_complete || !this.props.canEdit}
                />

                <Input
                  name="organizational_unit"
                  label={t("input.label.email.organizational_unit")}
                  placeholder={t("input.placeholder.organizational_unit")}
                  type="text"
                  onChange={setFormFieldValue}
                  value={formData.organizational_unit}
                  errors={formErrors.organizational_unit}
                  disabled={!features.addressbook_data_complete || !this.props.canEdit}
                />

                <Input
                  name="telephone"
                  label={t("input.label.domain.telephone")}
                  placeholder={t("input.placeholder.telephone")}
                  type="text"
                  onChange={setFormFieldValue}
                  value={formData.telephone}
                  errors={formErrors.telephone}
                  disabled={!features.addressbook_data_complete || !this.props.canEdit}
                />

                <Input
                  name="mobilephone"
                  label={t("input.label.email.mobilephone")}
                  placeholder={t("input.placeholder.mobilephone")}
                  type="text"
                  onChange={setFormFieldValue}
                  value={formData.mobilephone}
                  errors={formErrors.mobilephone}
                  disabled={!features.addressbook_data_complete || !this.props.canEdit}
                />

                <Input
                  name="fax"
                  label={t("input.label.email.fax")}
                  placeholder={t("input.placeholder.fax")}
                  type="text"
                  onChange={setFormFieldValue}
                  value={formData.fax}
                  errors={formErrors.fax}
                  disabled={!features.addressbook_data_complete || !this.props.canEdit}
                />

                <Input
                  className="inputFull2"
                  name="address"
                  label={t("input.label.address")}
                  placeholder={t("input.placeholder.address")}
                  type="text"
                  onChange={setFormFieldValue}
                  value={formData.address}
                  errors={formErrors.address}
                  disabled={!features.addressbook_data_complete || !this.props.canEdit}
                />

                <Input
                  name="zip"
                  label={t("input.label.postcode")}
                  placeholder={t("input.placeholder.postcode")}
                  type="text"
                  onChange={setFormFieldValue}
                  value={formData.zip}
                  errors={formErrors.zip}
                  disabled={!features.addressbook_data_complete || !this.props.canEdit}
                />

                <Input
                  name="city"
                  label={t("input.label.city")}
                  placeholder={t("input.placeholder.city")}
                  type="text"
                  onChange={setFormFieldValue}
                  value={formData.city}
                  errors={formErrors.city}
                  disabled={!features.addressbook_data_complete || !this.props.canEdit}
                />

                <Input
                  name="state"
                  label={t("input.label.state")}
                  placeholder={t("input.placeholder.state")}
                  type="text"
                  onChange={setFormFieldValue}
                  value={formData.state}
                  errors={formErrors.state}
                  disabled={!features.addressbook_data_complete || !this.props.canEdit}
                />

                <Input
                  name="country"
                  label={t("input.label.country")}
                  placeholder={t("input.placeholder.country")}
                  type="text"
                  onChange={setFormFieldValue}
                  value={formData.country}
                  errors={formErrors.country}
                  disabled={!features.addressbook_data_complete || !this.props.canEdit}
                />
              </AvailabilityBox>
            </div>
          </div>

          {loggedUserType !== "EmailAccount" && loggedUserType !== "Postmaster" && (
            <div className="sectionSP">
              <div className="infoSectionSP">
                <div className="settingTitle">{t("settings.sections.languageTimeZone.title")}</div>
                <div className="sectionDesc">{t("settings.sections.languageTimeZone.desc.emailAccount")}</div>
              </div>
              <div className="formsSectionSP">
                <Select
                  label={t("input.label.language")}
                  components={{ DropdownIndicator }}
                  name="language"
                  options={getPanelLangs()}
                  clearable={false}
                  onChange={setFormFieldValue}
                  value={formData.language}
                />

                <Select
                  label={t("input.label.timezone")}
                  components={{ DropdownIndicator }}
                  name="timezone"
                  options={tzs}
                  clearable={false}
                  onChange={setFormFieldValue}
                  value={formData.timezone}
                />
              </div>
            </div>
          )}
        </div>
      </form>
    );
  }
}
